import React from "react";
import { Box, Typography } from "@mui/material";
import { BadgeRounded } from "@mui/icons-material";

// Tarjeta resumen del socio, reutilizada por los modales de baja y alta.
// Muestra titular, DNI y plan en un formato compacto y consistente.
const Field = ({ label, value }) => (
  <Box sx={{ minWidth: 0 }}>
    <Typography
      sx={{
        fontSize: "11px",
        fontWeight: 600,
        letterSpacing: "0.4px",
        textTransform: "uppercase",
        color: "#8a929c",
      }}
    >
      {label}
    </Typography>
    <Typography
      sx={{
        fontSize: "14px",
        fontWeight: 600,
        color: "#002C54",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {value || "—"}
    </Typography>
  </Box>
);

export const PatientSummaryCard = ({ patient }) => {
  const fullName =
    patient?.lastName || patient?.firstName
      ? `${patient?.lastName ?? ""}${
          patient?.lastName && patient?.firstName ? ", " : ""
        }${patient?.firstName ?? ""}`
      : "";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "1rem",
        background: "#f6f8fa",
        border: "1px solid #e8ebef",
        borderRadius: "14px",
        padding: "1rem 1.25rem",
      }}
    >
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: "12px",
          background: "rgba(0,44,84,0.1)",
          color: "#002C54",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <BadgeRounded />
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1.6fr 1fr 1.4fr",
          gap: "1rem",
          flexGrow: 1,
          minWidth: 0,
        }}
      >
        <Field label="Titular" value={fullName} />
        <Field label="DNI" value={patient?.id_number} />
        <Field label="Plan" value={patient?.financer_plan} />
      </Box>
    </Box>
  );
};
